var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaginationLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#F5F5F5;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLP"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1-PLP",
    transform: "translate(-1190.000000, -3288.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    y: 160,
    className: "st0",
    width: 1920,
    height: 3408
  }), /*#__PURE__*/React.createElement("g", {
    id: "Paginator",
    transform: "translate(1030.000000, 3288.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_x2F_Arrow_x2F_Right",
    transform: "translate(160.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "st1",
    d: "M9.1,4L9.1,4c0.2,0.2,0.2,0.5,0,0.7L4.3,9.5l12.6,0c0.3,0,0.5,0.2,0.5,0.5 c0,0.3-0.2,0.5-0.5,0.5H4.3l4.8,4.8l0,0c0.2,0.2,0.2,0.5,0,0.6c-0.2,0.2-0.5,0.2-0.7,0L3,10.5c-0.2-0.1-0.3-0.3-0.3-0.5 c0,0,0,0,0,0c0-0.1,0-0.2,0.1-0.3L8.4,4l0,0C8.6,3.9,8.9,3.9,9.1,4z"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationLeft);
export default __webpack_public_path__ + "static/media/pagination-left.37cc287f.svg";
export { ForwardRef as ReactComponent };